function formatBundleMoney(cents) {
  const amount = cents / 100;
  try {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(amount);
  } catch (error) {
    return `R$ ${amount.toFixed(2).replace('.', ',')}`;
  }
}

class ProductBundleLadderController {
  constructor(root) {
    this.root = root;
    this.assinaButton = root.querySelector('[data-bundle-assina]');
    this.radios = root.querySelectorAll('[data-bundle-radio]');
    this.options = root.querySelectorAll('[data-bundle-option]');
    this.form = root.querySelector('[data-bundle-form]') || root.querySelector('form');
    this.variantInput = root.querySelector('[data-bundle-variant-input]');
    this.quantityInput = root.querySelector('[data-bundle-quantity-input]');
    this.addButton = root.querySelector('[data-bundle-add-to-cart]');
    this.buyNowButton = root.querySelector('[data-bundle-buy-now]');
    this.unitPrice = parseInt(root.dataset.unitPrice, 10) || 0;
    this.assinaQty = parseInt(root.dataset.assinaQty, 10) || 2;
    this.assinaDiscount = parseFloat(root.dataset.assinaDiscount) || 0;
    this.savingsTemplate = root.dataset.savingsTemplate || 'save [[amount]]';
    this.active = false;
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.onOptionChange(radio));
    });

    this.options.forEach((option) => {
      option.addEventListener('click', (event) => {
        const radio = option.querySelector('[data-bundle-radio]');
        if (!radio || radio.disabled) return;
        if (event.target === radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    if (this.assinaButton) {
      this.assinaButton.addEventListener('click', () => this.toggleAssina());
    }

    if (this.buyNowButton) {
      this.buyNowButton.addEventListener('click', () => this.buyNow());
    }

    if (this.form) {
      this.form.addEventListener('submit', () => {
        this.syncQuantity();
        if (this.variantInput) this.variantInput.disabled = false;
      });
    }

    const checked = root.querySelector('[data-bundle-radio]:checked');
    if (checked) this.onOptionChange(checked);
    this.syncQuantity();
  }

  onOptionChange(radio) {
    this.options.forEach((option) => {
      option.classList.toggle('is-selected', option.contains(radio) && radio.checked);
    });

    this.unitPrice = parseInt(radio.dataset.price, 10) || 0;
    this.root.dataset.unitPrice = String(this.unitPrice);

    const available = radio.dataset.available === 'true';
    const variantId = radio.dataset.variantId || radio.value || '';

    if (this.variantInput) {
      this.variantInput.value = variantId;
      this.variantInput.disabled = !available;
    }

    [this.addButton, this.buyNowButton].forEach((button) => {
      if (!button) return;
      if (available) {
        button.removeAttribute('disabled');
      } else {
        button.setAttribute('disabled', 'disabled');
      }
    });

    this.updateAssinaPrice();
  }

  selectByProductId(productId) {
    if (!productId) return false;
    const targetId = String(productId);
    const radio = Array.from(this.root.querySelectorAll('[data-bundle-radio]')).find(
      (el) => el.dataset.productId === targetId
    );
    if (!radio || radio.disabled) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  toggleAssina() {
    this.active = !this.active;
    this.assinaButton.classList.toggle('is-active', this.active);
    this.assinaButton.setAttribute('aria-pressed', this.active ? 'true' : 'false');
    this.syncQuantity();
  }

  getQuantity() {
    return this.active ? this.assinaQty : 1;
  }

  syncQuantity() {
    if (this.quantityInput) {
      this.quantityInput.value = String(this.getQuantity());
    }
  }

  updateAssinaPrice() {
    if (!this.assinaButton) return;

    const priceEl = this.assinaButton.querySelector('[data-bundle-assina-price]');
    if (!priceEl) return;

    const base = this.unitPrice * this.assinaQty;
    let sale = base;
    if (this.assinaDiscount > 0 && this.assinaDiscount < 100) {
      sale = Math.round((base * (100 - this.assinaDiscount)) / 100);
    }
    const savings = base - sale;

    let html = formatBundleMoney(sale);
    if (savings > 0) {
      const amountText = formatBundleMoney(savings);
      const savingsText = this.savingsTemplate.includes('[[amount]]')
        ? this.savingsTemplate.split('[[amount]]').join(amountText)
        : this.savingsTemplate.replace(/__amount__/gi, amountText);
      html += `<span class="product-bundle-ladder__assina-save" data-bundle-assina-save>${savingsText}</span>`;
    }
    priceEl.innerHTML = html;
  }

  setLoading(button, loading) {
    if (!button) return;
    button.classList.toggle('loading', loading);
    button.toggleAttribute('aria-disabled', loading);
    const spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !loading);
  }

  buyNow() {
    const selected = this.root.querySelector('[data-bundle-radio]:checked');
    if (!selected || selected.dataset.available !== 'true' || !this.variantInput) return;
    if (this.buyNowButton?.hasAttribute('aria-disabled')) return;

    this.syncQuantity();
    this.variantInput.disabled = false;
    this.setLoading(this.buyNowButton, true);

    const formData = new FormData();
    formData.append('id', this.variantInput.value);
    formData.append('quantity', String(this.getQuantity()));

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const message =
            response.description || response.message || window.cartStrings?.error || 'Erro ao adicionar ao carrinho';
          const errorWrapper = this.root.querySelector('.product-form__error-message-wrapper');
          const errorMessage = this.root.querySelector('.product-form__error-message');
          if (errorWrapper && errorMessage) {
            errorWrapper.removeAttribute('hidden');
            errorMessage.textContent = message;
          }
          return;
        }
        window.location = '/checkout';
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.setLoading(this.buyNowButton, false);
      });
  }
}

function initProductBundleLadders(scope = document) {
  scope.querySelectorAll('[data-product-bundle-ladder]:not([data-bundle-ladder-initialized])').forEach((root) => {
    root.dataset.bundleLadderInitialized = 'true';
    root._bundleLadderController = new ProductBundleLadderController(root);
  });
}

window.selectBundleLadderProduct = function selectBundleLadderProduct(productId) {
  let selected = false;
  document.querySelectorAll('[data-product-bundle-ladder]').forEach((root) => {
    if (!root._bundleLadderController) {
      root.dataset.bundleLadderInitialized = 'true';
      root._bundleLadderController = new ProductBundleLadderController(root);
    }
    if (root._bundleLadderController.selectByProductId(productId)) {
      selected = true;
    }
  });
  return selected;
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initProductBundleLadders());
} else {
  initProductBundleLadders();
}

document.addEventListener('shopify:section:load', (event) => {
  initProductBundleLadders(event.target);
});
